import {CommercialPackagesModel} from '../../../library/src/commercialPackages/models/CommercialPackagesModel';

export const GET_COMMERCIAL_PACKAGES = 'GET_COMMERCIAL_PACKAGES';
export interface GetCommercialPackagesAction {
  type: typeof GET_COMMERCIAL_PACKAGES;
}

export const GET_COMMERCIAL_PACKAGES_SUCCESS = 'GET_COMMERCIAL_PACKAGE_SUCCESS';
export interface GetCommercialPackagesSuccessAction {
  type: typeof GET_COMMERCIAL_PACKAGES_SUCCESS;
  payload: CommercialPackagesModel[];
}

export type SharedCommercialPackagesActionsType =
  | GetCommercialPackagesAction
  | GetCommercialPackagesSuccessAction;

export const sharedCommercialPackagesActions = {
  getCommercialPackages: (): GetCommercialPackagesAction => {
    return {
      type: GET_COMMERCIAL_PACKAGES,
    };
  },

  getCommercialPackagesSuccess: (
    data: CommercialPackagesModel[],
  ): GetCommercialPackagesSuccessAction => {
    return {
      type: GET_COMMERCIAL_PACKAGES_SUCCESS,
      payload: data,
    };
  },
};
